import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    officialBadgesWrapper: {
        display: "flex",
        gap: theme.spacing.sm,
        flexWrap: "wrap",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: rem(6),
    },
    containerIcon: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignContent: "center",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: rem(6),
    },
    button: {
        width: "fit-content",
        fontSize: "0.875rem",
        lineHeight: "0.875rem",
        height: "2rem",
        padding: "0.5rem 0.75rem",
    },
    pill: {
        display: "flex",
        height: rem(30),
        padding: `${rem(4)} ${rem(8)}`,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: rem(4),
        cursor: "pointer",
        backgroundColor: theme.colors.gray[1],
        color: theme.colors.gray[7],
        fontSize: rem(16),
        fontStyle: "normal",
        gap: rem(12),
        border: `1px solid ${theme.colors.gray[3]}`,
    },
    actionIcon: {
        minWidth: 0,
        width: "fit-content",
        "& #ds-icon": {
            minWidth: 0,
            width: "fit-content",
        },
    },
}))
